class StockLocationStockEventController extends AbstractStockLocationController
	@register()
	@inject 'translate',
		'RenderRepository'
		'StockEventsRepository'
		'StockLocationRepository'
		'stockLocation'
		'reasonCodes'
		'translate'
		'SEARCH_CONFIGURATION'

	initialize: ->
		super()

		@filterDTO = new FilterDTO({
			searchConfiguration: @SEARCH_CONFIGURATION.stock_event
			pageSize: @StockEventsRepository.getPageSize()
			itemsCount: 0
			sortProperty: 'timestamp'
		})

		@events = []
		@filter =
			all: {}
			current: {}

		# sort to show deleted codes at the bottom of <select/> element
		@reasonCodes = @sortObjectByProperty(@reasonCodes, 'deleted')

		@refreshEventsFilter()
		@initializeReasonCodes()

	search: ->
		@searching = true

		query = @filterDTO.getQuery()
		query.criteria('stock_location_id', '=', @stockLocation.id)

		@refreshEventsFilter()

		@StockEventsRepository
			.getEntities query
			.then (events) =>
				@events = events

				for event in @events
					event.reason_code = @reasonCodes[event.reason_code_id]

				@filterDTO.itemsCount = @events.length
			.catch (response) =>
				@handleErrors response, 'wbo.stock.events'
			.finally =>
				@searching = false

	refreshEventsFilter: ->
		@allEventsFilter = angular.copy @filterDTO.getFilter()

		if @allEventsFilter.timestamp?
			@allEventsFilter.start_time = @allEventsFilter.timestamp.start
			@allEventsFilter.end_time = @allEventsFilter.timestamp.end

			delete @allEventsFilter.timestamp

		@filter = angular.copy @allEventsFilter
		@filter.stock_location_id = @stockLocation.id

	initializeReasonCodes: ->
		# title = final name shown to user (name + label + deletedText)
		# name = original entity name
		# label = entity_type (name of reason_code.entity_type)
		# deletedText = shown on soft deleted codes

		deletedText = '[' + @translate('general.deleted') + '] '

		for id, reasonCode of @reasonCodes
			reasonCode.title = reasonCode.name + ' - ' + @translate(reasonCode.label)

			if reasonCode.deleted
				reasonCode.title = deletedText + reasonCode.title

	###
  Sort an object that is used as an associative array, by its elements property value
  Performs stable sort
  ###
	sortObjectByProperty: (list, propertyName) ->
		keys = []
		for id, item of list
			keys.push({id: id, property: item[propertyName]})

		keys = _.sortBy(keys, 'property')

		sortedItems = {}

		for key in keys
			sortedItems[key.id] = list[key.id]

		return sortedItems

	getAdvancedSearchValues: (filterKey) ->
		if filterKey == 'reason_code_id'
			reasonCodes = Object.values(@reasonCodes)

			for reasonCode in reasonCodes
				reasonCode.label_text = @translate(reasonCode.label)

			return @StockLocationRepository.resolve(reasonCodes)

		if filterKey == 'product_id'
			return @StockLocationRepository.getProducts(@stockLocation.id)

		return @StockLocationRepository.resolve()
